module.exports = __webpack_public_path__ + "static/media/encerrada_caminhao_recordar.ebd25518.jpg";